import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export type OnboardingKycResultSuccessProps = EventProps

/**
 * @event onboarding_kyc_result_success
 * @description Emitted when the FrankieOne KYC verification completes successfully.
 */
export const OnboardingKycResultSuccessAnalytics = createAnalyticsStatic<OnboardingKycResultSuccessProps>(
    ANALYTICS_EVENTS.ONBOARDING.ONBOARDING_KYC_RESULT_SUCCESS,
)

export default OnboardingKycResultSuccessAnalytics
